import _ from 'lodash';
import uri from 'urijs';
import createAction from '../services/create-action';
import { buildPaginationRequestParams } from '../services/pagination';

export const FETCH_FOLLOWING_REQUEST = 'following/FETCH_REQUEST';
export const FETCH_FOLLOWING_SUCCESS = 'following/FETCH_SUCCESS';
export const FETCH_FOLLOWING_FAILURE = 'following/FETCH_FAILURE';

export const fetchFollowingRequest = createAction(FETCH_FOLLOWING_REQUEST);
export const fetchFollowingSuccess = createAction(FETCH_FOLLOWING_SUCCESS, _.identity, (payload, meta) => meta);
export const fetchFollowingFailure = createAction(FETCH_FOLLOWING_FAILURE);

export function fetchFollowing({ userId, page, pageSize }) {
  return (dispatch, getState, { request }) => {
    dispatch(fetchFollowingRequest());

    const query = buildPaginationRequestParams(page, pageSize);
    const promise = request(uri(`/_api/users/${userId}/following`).query(query), { parseHeaders: true });
    return promise
      .then(({ body = [], headers = {} }) => {
        const payload = { following: body };
        const meta = { count: parseInt(headers.get('Wix-Forum-TotalResults'), 10) };
        return dispatch(fetchFollowingSuccess(payload, meta));
      })
      .catch(() => dispatch(fetchFollowingFailure()))
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/fetch-following.js